
import { useGetFarmInfo, useAddFarmInfo, useSelfAddFarm, useSelfAddProdPlace } from 'hooks/useFarms';
import { useAllCountries } from 'hooks/useOther';
import { useAccountInfo } from 'hooks/useAccount';
import { useUpdateAccountInfo } from 'hooks/useAccount';

export default function useRegisterFarmForm () {

  const { isLoading: isFetchingAccountInfo, data: accountInfo, refetch: refetchAccountInfo, isSuccess: hasFetchedAccountInfo, isError: failedFetchingAccountInfo } = useAccountInfo();
  const { isLoading: isSelfAddingFarm, mutate: selfAddFarm, mutateAsync: selfAddFarmAsync, isSuccess: hasSelfAddedFarm, isError: failedSelfAddingFarm } = useSelfAddFarm();
  const { isLoading: isSelfAddingProdPlace, mutateAsync: selfAddProdPlace, isError: failedSelfAddingProdPlace } = useSelfAddProdPlace();
  // const { isLoading: isFetchingProdPlaceInfo, mutate: fetchProdplaceData, data: prodPlaceInfo, isSuccess: hasFetchedProdPlaceInfo, isError: failedFetchingProdPlaceInfo } = useGetProdPlacesByFarm();
  const { isLoading: isFetchingAllCountries, data: allCountries, isSuccess: hasFetchedAllCountries, isError: failedFetchingAllCountries } = useAllCountries();
  
  return {
    currentFarmId: null,
    isFetchingAllCountries,
    allCountries,
    hasFetchedAllCountries,
    failedFetchingAllCountries,
    // isFetchingProdPlaceInfo,
    // prodPlaceInfo,
    // hasFetchedProdPlaceInfo,
    // failedFetchingProdPlaceInfo,
    // fetchProdplaceData,
    isFetchingAccountInfo,
    accountInfo,
    refetchAccountInfo,
    failedFetchingAccountInfo,

    hasFetchedAccountInfo,
    isSelfAddingFarm,
    selfAddFarm,
    selfAddFarmAsync,
    hasSelfAddedFarm,
    failedSelfAddingFarm,
    isSelfAddingProdPlace,
    selfAddProdPlace,
    failedSelfAddingProdPlace,
  };

}
